import { GeoJSON } from 'react-leaflet'
import { observer } from 'mobx-react'

// Extend react-leaflet GeoJSON to support a mutable
// `positions` prop which is an array of points for the geometry.
// Also handle changes to the `className` prop, and allow the geometry
// to be added to the back of the layer with a `startInBack` prop.
@observer class DynamicGeoJSON extends GeoJSON {
  componentDidMount () {
    super.componentDidMount()

    if (this.props.startInBack === true) {
      if (this.leafletElement && typeof this.leafletElement.bringToBack === 'function') {
        this.leafletElement.bringToBack()
      }
    }
    if (this.props.bringToFront === true) {
      this.bringLayerToFront()
    }
  }

  bringLayerToFront () {
    if (this.leafletElement) {
      if (typeof this.leafletElement.bringToFront === 'function') {
        this.leafletElement.bringToFront()
      }
      if (typeof this.leafletElement.eachLayer === 'function') {
        this.leafletElement.eachLayer(layer => {
          if (layer && typeof layer.bringToFront === 'function') {
            layer.bringToFront()
          }
        })
      }
    }
  }

  updateLeafletElement (fromProps, toProps) {
    if (toProps.positions !== fromProps.positions) {
      this.leafletElement.setLatLngs(toProps.positions)
    }

    const nextStyle = {
      color: toProps.color,
      fillColor: toProps.fillColor,
      weight: toProps.weight,
      opacity: toProps.opacity,
      fillOpacity: toProps.fillOpacity,
      ...(toProps.style || {})
    }

    if (this.leafletElement) {
      if (typeof this.leafletElement.setStyle === 'function') {
        this.leafletElement.setStyle(nextStyle)
      }
      if (typeof this.leafletElement.eachLayer === 'function') {
        this.leafletElement.eachLayer(layer => {
          if (layer && typeof layer.setStyle === 'function') {
            layer.setStyle(nextStyle)
          }
        })
      }
    }

    if (toProps.className !== fromProps.className) {
      this.leafletElement.eachLayer(layer => {
        if (layer && layer._path) {
          layer._path.setAttribute('class', toProps.className)
        }
      })
    }

    this.setStyleIfChanged(fromProps, toProps)

    if (toProps.bringToFront === true) {
      this.bringLayerToFront()
    }
  }
}

export default DynamicGeoJSON
